/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export enum SORT_FILTERS {
  app_name = "app_name",
  monthly_costs = "monthly_costs",
  prev_month_costs = "prev_month_costs",
  monthly_forecast_costs = "monthly_forecast_costs",
  resources = "resources",
  environments = "environments",
}

export const SELECT_OPTIONS = [
  {
    value: SORT_FILTERS.app_name,
    label: "Application Name",
  },
  {
    value: SORT_FILTERS.monthly_costs,
    label: "Monthly Costs",
  },
  {
    value: SORT_FILTERS.prev_month_costs,
    label: "Previous Month Costs",
  },
  {
    value: SORT_FILTERS.monthly_forecast_costs,
    label: "Monthly Forecast Costs",
  },
  {
    value: SORT_FILTERS.resources,
    label: "Resources",
  },
  {
    value: SORT_FILTERS.environments,
    label: "Environments",
  },
];
